import { useEffect, useState } from "react";

export function WidgetPingstationStatus({ pingstations }) {
    const [overallStatus, setOverallStatus] = useState(true);
    const [pingstationList, setPingstationList] = useState(pingstations);

    useEffect(() => {
        refreshPingstation(pingstations);
    }, [pingstations]);

    function refreshPingstation(pingstations) {
        // check last_heard date/time for each pingstation
        const updatedPingstationList = pingstations.map((pingstation) => {
            const lastHeard = new Date(pingstation.last_heard).getTime();
            const now = new Date().getTime();
            const diff = now - lastHeard;
            const minutes = Math.floor(diff / 1000 / 60); // convert milliseconds to minutes - 1000ms = 1s, 60s = 1m

            return {
                ...pingstation,
                up: minutes <= 5,
            };
        });

        // check if all pingstations are up
        const isAllUp = updatedPingstationList.every((pingstation) => pingstation.up);

        setOverallStatus(isAllUp);
        setPingstationList(updatedPingstationList);
    }

    return <div className="grid grid-cols-1 gap-4 md:grid-cols-2 bg-white mt-10 p-6 rounded-md shadow-sm">
        <div>
            <h2 className="font-semibold block text-gray-500">OVERALL STATUS</h2>
            {overallStatus ? <p className="font-semibold text-3xl mt-5 block text-green-500">All pingstation are up.</p> : <p className="font-semibold text-3xl mt-5 block text-red-500">Some pingstations are down.</p>}
        </div>

        <div>
        <h2 className="font-semibold block text-gray-500">DOWN STATIONS</h2>
        {pingstationList.filter((pingstation) => !pingstation.up).map((pingstation) => (
            <div key={pingstation.id} className="flex justify-between items-center pt-2">
                <div>
                    <p className="font-semibold text-lg">{pingstation.airport_code}</p>
                    <p className="text-sm text-gray-500">{pingstation.pingstation_id}</p>
                    <p className="text-sm text-gray-500">Last Heard: {new Date(pingstation.last_heard).toLocaleString()}</p>
                </div>
                <p className="font-semibold text-red-500">DOWN</p>
            </div>
        )) || <p className="text-green-500">All pingstations are up.</p>}
        </div>
    </div>
}